import React from "react";

export interface IRaangeDataTableRowNumberProps {
  index: number;
}

export const RaangeDataTableRowNumberHeader = () => <th />;

export const RaangeDataTableRowNumber = ({
  index,
}: IRaangeDataTableRowNumberProps) => <th>{index + 1}</th>;
